import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const LottieContainer = styled.div`
  width: ${props => props.width || '100%'};
  height: ${props => props.height || 'auto'};
  max-width: ${props => props.maxWidth || '100%'};
  margin: ${props => props.margin || '0 auto'};
  display: flex;
  justify-content: ${props => props.align || 'center'};
  align-items: center;
`;

const PlaceholderBox = styled.div`
  width: 100%;
  height: 250px;
  background: var(--glass-1);
  border: 1px dashed var(--glass-border);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  font-size: 13px;
  gap: 10px;

  svg {
    width: 32px;
    height: 32px;
    color: var(--accent);
  }
`;

const LottieAnimationWidget = ({ node, isLiveMode }) => {
  const url = node.content?.jsonUrl || '';
  const loop = node.content?.loop !== false;
  const autoplay = node.content?.autoplay !== false;
  
  const width = node.style?.desktop?.width || '100%';
  const align = node.style?.desktop?.align || 'center';

  return (
    <LottieContainer width="100%" align={align}>
      {url ? (
        <lottie-player 
          src={url} 
          background="transparent" 
          speed="1" 
          style={{ width: width, maxWidth: '100%' }} 
          loop={loop ? "" : undefined}
          autoplay={autoplay ? "" : undefined}
        ></lottie-player>
      ) : (
        <PlaceholderBox>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>
          <div>Lottie Animation (URL eintragen)</div>
        </PlaceholderBox>
      )}
    </LottieContainer>
  );
};

registry.register('lottie_animation', {
  label: 'Lottie Animation',
  icon: '✨',
  category: 'advanced',
  defaultContent: {
    jsonUrl: '',
    loop: true,
    autoplay: true
  },
  defaultStyle: {
    desktop: {
      width: '300px',
      align: 'center'
    }
  },
  render: LottieAnimationWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Lottie Quelle',
          fields: [
            { name: 'content.jsonUrl', label: 'JSON URL (Lottie)', type: 'text' }
          ]
        },
        {
          title: 'Verhalten',
          fields: [
            { name: 'content.loop', label: 'Endlosschleife (Loop)', type: 'select', options: [{label: 'Ja', value: true}, {label: 'Nein', value: false}] },
            { name: 'content.autoplay', label: 'Autoplay', type: 'select', options: [{label: 'Ja', value: true}, {label: 'Nein', value: false}] }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Dimensionen & Ausrichtung',
          fields: [
            { name: 'style.desktop.width', label: 'Breite (z.B. 100%, 300px)', type: 'text' },
            { name: 'style.desktop.align', label: 'Ausrichtung', type: 'select', options: [{label: 'Links', value: 'flex-start'}, {label: 'Zentriert', value: 'center'}, {label: 'Rechts', value: 'flex-end'}] }
          ]
        }
      ]
    }
  ]
});
